/* eslint-disable no-undef */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//@ts-ignore
import { noop } from '@mindtickle/utils';
import { getHighResolutionTime } from '../../../utils';
import { getExtendedLogger } from '../../Logger';
import logger from '../../../config/app.logger';
import { LOGGER_NAME } from '../config/constants';
var log = getExtendedLogger(LOGGER_NAME, logger);
export var loadRemoteModule = function (remote, module, remoteModuleLoadedCallback) {
    if (remoteModuleLoadedCallback === void 0) { remoteModuleLoadedCallback = noop; }
    return __awaiter(void 0, void 0, void 0, function () {
        var startModuleLoadingTime, container, error_1, factory, Module;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    startModuleLoadingTime = getHighResolutionTime();
                    // Initializes the share scope. This fills it with known provided modules from this build and all remotes
                    return [4 /*yield*/, __webpack_init_sharing__('default')];
                case 1:
                    // Initializes the share scope. This fills it with known provided modules from this build and all remotes
                    _a.sent();
                    container = window[remote];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    // Initialize the container, it may provide shared modules
                    return [4 /*yield*/, container.init(__webpack_share_scopes__.default)];
                case 3:
                    // Initialize the container, it may provide shared modules
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    // Container was already initialized
                    log(error_1);
                    return [3 /*break*/, 5];
                case 5: return [4 /*yield*/, window[remote].get(module)];
                case 6:
                    factory = _a.sent();
                    Module = factory();
                    container.__dynamically_initialised__ = true;
                    remoteModuleLoadedCallback(getHighResolutionTime() - startModuleLoadingTime);
                    return [2 /*return*/, Module];
            }
        });
    });
};
export var isRemoteLoaded = function (remote) { return !!window[remote]; };
export var isRemoteIntialised = function (remote) {
    return isRemoteLoaded(remote) && !!window[remote].__dynamically_initialised__;
};
export var getModuleFromInitalisedRemote = function (remote, module) { return __awaiter(void 0, void 0, void 0, function () {
    var factory;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, window[remote].get(module)];
            case 1:
                factory = _a.sent();
                return [2 /*return*/, factory()];
        }
    });
}); };
//# sourceMappingURL=remote.js.map